var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferredMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 49,
    viewBox: "0 0 35 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_6842)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_83_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4604 34.27C26.6062 34.27 34.0204 26.8559 34.0204 17.71C34.0204 8.56419 26.6062 1.15002 17.4604 1.15002C8.31455 1.15002 0.900391 8.56419 0.900391 17.71C0.900391 26.8559 8.31455 34.27 17.4604 34.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 0.0500517C12.8504 0.0527029 8.40182 1.89762 5.1221 5.17922C1.84237 8.46082 -7.57478e-07 12.9105 0 17.5501C0 27.2101 17.49 48.1001 17.49 48.1001C17.49 48.1001 35 27.2101 35 17.5501C35 15.2511 34.547 12.9746 33.6669 10.8508C32.7869 8.72693 31.4969 6.7973 29.8708 5.17215C28.2447 3.54699 26.3144 2.25816 24.19 1.37929C22.0657 0.500419 19.789 0.048738 17.49 0.0500517ZM17.49 32.2201C14.5857 32.222 11.7461 31.3625 9.33047 29.7502C6.91482 28.1379 5.0317 25.8453 3.91937 23.1625C2.80703 20.4796 2.51548 17.5272 3.08159 14.6786C3.6477 11.83 5.04604 9.21336 7.09968 7.15973C9.15331 5.10609 11.77 3.70775 14.6185 3.14164C17.4671 2.57553 20.4196 2.86708 23.1024 3.97942C25.7852 5.09175 28.0778 6.97487 29.6901 9.39052C31.3024 11.8062 32.162 14.6458 32.16 17.5501C32.16 19.4765 31.7805 21.3842 31.0433 23.164C30.3061 24.9439 29.2255 26.5611 27.8633 27.9233C26.501 29.2855 24.8838 30.3661 23.104 31.1034C21.3241 31.8406 19.4165 32.2201 17.49 32.2201Z",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2702 18.1401L24.7502 14.8801H19.2102L17.5002 9.61011L15.7802 14.8801H10.2402L14.7202 18.1401L13.0102 23.4101L17.4902 20.1501L21.9802 23.4101L20.2702 18.1401Z",
    fill: "#EB1700"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_6842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.99,
    height: 48.05,
    fill: "white",
    transform: "translate(0 0.0500488)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_83_6842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.99,
    height: 48.05,
    fill: "white",
    transform: "translate(0 0.0500488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferredMark);
export default __webpack_public_path__ + "static/media/PreferredMark.d8a771fef06ca920684844c8342685cc.svg";
export { ForwardRef as ReactComponent };